import { DestinationDetailContainer } from "../../../containers";
function DestinationDetail() {
  return <DestinationDetailContainer  />;
}
export default DestinationDetail;
